<template>
  <div class="mt-48">
    <div class="container max-w-screen-2xl">
      <div class="grid grid-cols-2 gap-x-16 items-center">
        <div class="">
          <img src="@/assets/img/samples/features/cancel-flows/cancel-flow-home-hero.svg" alt="Set up cancel flows" class="w-full" />
        </div>
        <div class="max-w-lg">
          <p class="title"><span class="text-green-500">Double your churn reduction</span> by enabling cancel flows.</p>
          <p class="subtitle mt-4 text-brand-brown">
            This is the workhorse of your retention engine. Get a primary cancel flow in place in minutes. Later, you'll create specific flows for
            unique customer segments.
          </p>
          <div class="space-y-6 mt-8" v-loading="loading">
            <div v-for="step in steps" :key="step.value" class="flex items-center space-x-4" style="max-width: 420px">
              <button
                class="flex items-center space-x-4 rounded-lg px-4 py-4 flex-grow"
                @click="handleStepClick(step)"
                :disabled="!!step.completed"
                :class="[step.completed ? 'cursor-default bg-gray-600' : 'bg-gray-800 cursor-pointer hover:bg-gray-700 transition-colors']"
              >
                <span class="px-2.5 py-1 border-gray-400 border-2 rounded-md bg-gray-600 text-white text-xs font-bold">
                  {{ step.shortcut }}
                </span>
                <span class="text-white font-bold" :class="[step.completed ? 'line-through' : '']">{{ step.label }}</span>
              </button>
              <div class="w-24">
                <div v-if="step.completed" class="text-brand-black text-sm font-semibold flex items-center space-x-1.5">
                  <font-awesome-icon :icon="['fas', 'check']" class="text-xs"></font-awesome-icon>
                  <span>Done</span>
                </div>
                <div v-else class="text-brand-black text-sm font-medium">
                  {{ step.hint }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CREATE_BLUEPRINT, SYNC_ORG } from '@/store/action-types';
import { mapGetters } from 'vuex';

const onboardSteps = [{ value: 'flow', label: 'Create your cancel flow', shortcut: 'return', hint: 'Takes 5 mins' }];

export default {
  name: 'BuildFirstFlowCard',
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters(['primaryBlueprintId']),
    steps() {
      return onboardSteps.map((step) => ({
        ...step,
        completed: false,
      }));
    },
  },
  mounted() {
    document.addEventListener('keyup', this.onKeyup);
  },
  beforeDestroy() {
    document.removeEventListener('keyup', this.onKeyup);
  },
  methods: {
    onKeyup(event) {
      if (event.key === 'Enter') {
        this.createBlueprint();
      }
    },
    async handleStepClick(step) {
      if (step.completed) {
        return;
      }
      if (step.value === 'flow') {
        this.createBlueprint();
      }
    },
    async createBlueprint() {
      this.loading = true;
      this.creatingBlueprint = true;
      // create a blueprint if there isn't one
      if (!this.primaryBlueprintId) {
        await this.$store.dispatch(CREATE_BLUEPRINT);
        await this.$store.dispatch(SYNC_ORG);
      }
      this.$router.push({ name: 'builder', params: { id: this.primaryBlueprintId } });
    },
  },
};
</script>
